import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { Button, Input } from "../../components";
import { AuthResetPassword } from "../../utilities/api/auth/auth-service";
import { Form } from "react-bootstrap";
import { messages } from "../../utilities/Messages";
const getMessage = messages.resetPassword;

const ResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [otp, setOtp] = useState(new Array(4).fill(""));
  const [Password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [showPassword, setShowPassword] = useState("false");

  let otpNo = location.state.otpNumber;

  useEffect(() => {
    document.body.classList.add("reset-page");
    return () => {
      document.body.classList.remove("reset-page");
    };
  }, []);

  const ResetPass = async () => {
    const result = await AuthResetPassword({
      phone: location.state.phone,
      otpNumber: Number(otp.join("")),
      newPassword: Password,
    });
    if (result.status === 200) {
      navigate("/", { state: { message: result.data.message } });
    } else {
      toast.error(result.response.data.message);
    }
  };

  const handleClick = (e: any) => {
    e.preventDefault();
    setPasswordError("");
    setConfirmPasswordError("");

    if (!/^\S+$/.test(Password)) {
      setPasswordError(getMessage.password_isNotContainSpace);
      return;
    }
    if (!/^\S+$/.test(confirmPassword)) {
      setConfirmPasswordError(getMessage.password_isNotContainSpace);
      return;
    }
    if (Password !== confirmPassword) {
      setConfirmPasswordError(getMessage.password_match);
      return;
    }
    ResetPass();
  };

  const handleKeyDown = (e: any, index: number) => {
    if (e.key === "Backspace") {
      if (otp[index]) {
        const newOtp = [...otp];
        newOtp[index] = "";
        setOtp(newOtp);
      } else if (index > 0) {
        const newOtp = [...otp];
        newOtp[index - 1] = "";
        setOtp(newOtp);
        e.target.previousSibling?.focus();
      }
      e.preventDefault();
    }
  };

  const handleChange = (element: any, index: number) => {
    if (isNaN(element.value)) return false;

    setOtp([...otp.map((ele, ind) => (ind === index ? element.value : ele))]);

    if (element.nextSibling) {
      element.nextSibling.focus();
    }
  };
  return (
    <>
      <div className="container">
        <div
          className="row justify-content-center align-items-center"
          style={{ height: "84vh" }}
        >
          <div className="col-md-5">
            <div className="position-relative">
              <div className="card">
                <div className="card-body">
                  <form>
                    <h3 className="card-title mb-3 text-start">
                      Reset Password
                    </h3>
                    <div className="mb-3 mt-1">
                      <span className="fs-6 text-info">
                        {otpNo}
                      </span>
                      {/* <span className="fs-6 text-info">
                        {message}-{otpNo}
                      </span> */}
                    </div>
                    <div className="row">
                      <div className="col-md-8">
                        <div
                          id="otp"
                          className="inputs d-flex flex-row justify-content-center mt-1"
                        >
                          {otp.map((item, index) => {
                            return (
                              <Input
                                autoFocus={index === 0 ? true : false}
                                onChange={(e: any) => handleChange(e.target, index)}
                                onKeyDown={(e: any) => handleKeyDown(e, index)}
                                key={index + "resetotpinput"}
                                onFocus={(e: any) => e.target.select()}
                                value={item}
                                maxLength="1"
                                placeholder="-"
                                name="otp"
                                className="text-center form-control me-2 py-4"
                                type="text"
                                id={`${index}indexotp`}
                              />
                            );
                          })}
                        </div>
                      </div>
                    </div>

                    <div className="mb-3 text-start mt-4">
                      <label htmlFor="password" className="form-label">
                        Password <small className="text-danger">*</small>
                      </label>
                      <Input
                        onChange={(e: any) => setPassword(e.target.value)}
                        type={showPassword === "true" ? "text" : "password"}
                        placeholder="Enter Password"
                        id="resetpasswordinput"
                        name="resetpasswordinput"
                        className="form-control"
                      />
                      {passwordError && (
                        <span className="error-msg">{passwordError}</span>
                      )}
                    </div>
                    <div className="mb-3 text-start">
                      <label htmlFor="cpassword" className="form-label">
                        Confirm Password{" "}
                        <small className="text-danger">*</small>
                      </label>
                      <Input
                        onChange={(e: any) =>
                          setConfirmPassword(e.target.value)
                        }
                        type={showPassword === "true" ? "text" : "password"}
                        placeholder="Enter Confirm Password"
                        id="resetconfirmpasswordinput"
                        name="resetconfirmpasswordinput"
                        className="form-control"
                      />
                      {confirmPasswordError && (
                        <span className="error-msg">{confirmPasswordError}</span>
                      )}
                    </div>
                    <div className="mb-3 text-start">
                      <Form.Check
                        onChange={(e: any) =>
                          setShowPassword(
                            showPassword === "false" ? "true" : "false"
                          )
                        }
                        label="Show Password"
                        name="showPassword"
                        type="checkbox"
                        id="showPassword"
                        value={showPassword === "false" ? "true" : "false"}
                        checked={showPassword === "false" ? false : true}
                      />
                    </div>
                    <div className="row">
                      <div className="col-md-6 text-start">
                        <NavLink to="/">Back to Login</NavLink>
                      </div>
                      <div className="col-md-6 text-end">
                        <Button
                          onClick={handleClick}
                          bname="Submit"
                          name="resetpasswordinput"
                          id="resetpasswordinput"
                          className="btn btn-primary rounded-1"
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};
export { ResetPassword };
